import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { withOfferChildsReducer, withOfferChildsSaga } from './withReducer';

import { Button, Input } from 'antd';
import {
  storeChildOffer,
  deleteChildOffer,
  updateChildOffer,
  setEditMode,
  unsetEditMode,
  resetErrors
} from './actions';
import { makeSelectIsLoading, makeSelectChildEditing } from './selectors';

import './item.scss';

class ChildItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: this.props.editMode === this.props.id,
      canEdit: this.props.editMode === false,
      newDeposit: this.props.deposit,
      newDistance: this.props.distance,
      newDuration: this.props.duration,
      newMonthlyRate: this.props.monthly_rate,
    };

    this.handleOnDepositChange = this.handleOnDepositChange.bind(this);
    this.handleOnDurationChange = this.handleOnDurationChange.bind(this);
    this.handleOnDistanceChange = this.handleOnDistanceChange.bind(this);
    this.handleOnPriceChange = this.handleOnPriceChange.bind(this);
    this.handleOnEditToggle = this.handleOnEditToggle.bind(this);
    this.handleOnUpdate = this.handleOnUpdate.bind(this);
    this.handleOnDelete = this.handleOnDelete.bind(this);
    this.handleOnAddChild = this.handleOnAddChild.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.editMode !== this.props.editMode) {
      this.setState({
        editMode: this.props.editMode === this.props.id,
        canEdit: this.props.editMode === false,
      });
    }
  }

  handleOnAddChild() {
    const { newDeposit, newDistance, newDuration, newMonthlyRate } = this.state;

    this.props.storeChildOffer({
      deposit: newDeposit,
      distance: newDistance,
      duration: newDuration,
      monthlyRate: newMonthlyRate,
    });

    this.setState({
      newDeposit: '',
      newDistance: '',
      newDuration: '',
      newMonthlyRate: '',
    });

    if (this.props.isCloningRow) {
      this.props.onClone();
    }
  }

  handleOnDepositChange({ target: { value } }) {
    const newValue = parseInt(value);
    this.props.resetErrors();
    this.setState({ newDeposit: isNaN(newValue) ? '' : newValue });
  }

  handleOnDurationChange({ target: { value } }) {
    const newValue = parseInt(value);
    this.props.resetErrors();
    this.setState({ newDuration: isNaN(newValue) ? '' : newValue });
  }

  handleOnDistanceChange({ target: { value } }) {
    const newValue = parseInt(value);
    this.props.resetErrors();
    this.setState({ newDistance: isNaN(newValue) ? '' : newValue });
  }

  handleOnPriceChange({ target: { value } }) {
    const newValue = parseInt(value);
    this.setState({ newMonthlyRate: isNaN(newValue) ? '' : newValue });
  }

  handleOnEditToggle() {
    if (this.canEdit) {
      this.props.setEditMode(this.props.id);
    } else {
      this.setState({
        newDeposit: this.props.deposit,
        newDistance: this.props.distance,
        newDuration: this.props.duration,
        newMonthlyRate: this.props.monthly_rate,
      })
      this.props.unsetEditMode();
    }

    if (this.props.isCloningRow) {
      this.props.onClone();
    }
  }

  handleOnUpdate() {
    this.props.updateChildOffer(this.props.id, this.state);
  }

  handleOnDelete() {
    if (confirm('Sicuro di voler cancellare questa variazione?')) {
      this.props.deleteChildOffer(this.props.id);
    }
  }

  get canEdit() {
    return this.props.editMode === false;
  }

  canSubmit() {
    return (
      this.state.newDeposit >= 0 &&
      this.state.newDistance > 0 &&
      this.state.newDuration > 0 &&
      this.state.newMonthlyRate > 0
    );
  }

  inputHasErrors() {
    const { newDeposit, newDistance, newDuration, newMonthlyRate } = this.state;
    const {
      mainDeposit,
      mainDistance,
      mainDuration,
      mainMonthlyRate,
      hasError,
    } = this.props;

    return (
      (mainDeposit === newDeposit &&
        mainDistance === newDistance &&
        mainDuration === newDuration &&
        mainMonthlyRate === newMonthlyRate)
        || hasError
    );
  }

  render() {
    const { id, isLoading, canClone, onClone, isCloningRow } = this.props;
    const {
      editMode,
      newDeposit,
      newDistance,
      newDuration,
      newMonthlyRate
    } = this.state;

    const inputClassName = this.inputHasErrors() ? 'has-error text-left' : 'text-left';

    return (
      <tr>
        <td width="22%" className={inputClassName}>
          {editMode || !id ?
            <Input
              name="deposit"
              type="number"
              min="0"
              placeholder="Anticipo"
              suffix="€"
              onChange={this.handleOnDepositChange}
              value={newDeposit}
              disabled={isLoading}
              autoFocus
            />
          : `${newDeposit} €`}
        </td>
        <td width="22%" className={inputClassName}>
          {editMode || !id ?
            <Input
              name="distance"
              type="number"
              min="0"
              max="100000"
              placeholder="Km annui"
              suffix="Km"
              onChange={this.handleOnDistanceChange}
              value={newDistance}
              disabled={isLoading}
            />
          : `${newDistance} Km/Anno`}
        </td>
        <td width="22%" className={inputClassName}>
          {editMode || !id ?
            <Input
              name="duration"
              type="number"
              min="0"
              max="72"
              placeholder="Numero di mesi"
              suffix="Mesi"
              onChange={this.handleOnDurationChange}
              value={newDuration}
              disabled={isLoading}
            />
          : `${newDuration} mesi`}
        </td>
        <td width="22%" className={inputClassName}>
          {editMode || !id ?
            <Input
              name="monthly_rate"
              type="number"
              min="0"
              placeholder="Canone mensile"
              suffix="€"
              onChange={this.handleOnPriceChange}
              value={newMonthlyRate ? parseInt(newMonthlyRate) : null}
              disabled={isLoading}
            />
          : `${newMonthlyRate ? parseInt(newMonthlyRate) : ''} €`}
        </td>
        <td className="row-actions" width="12%">
          {id ?
          <Button.Group className="nowrap">
            {editMode ?
              <Button
                icon="check"
                title="Salva modifiche"
                onClick={this.handleOnUpdate}
                className="save-btn"
                loading={isLoading}
              />
              :
              <Button
                icon="edit"
                title="Modifica"
                onClick={this.handleOnEditToggle}
                disabled={!this.canEdit || !canClone}
              />
            }
            <Button
              icon="copy"
              title="Duplica"
              onClick={onClone}
              disabled={editMode || !this.canEdit || !canClone}
            />
            {editMode ?
              <Button
                icon="close"
                title="Annulla modifiche"
                onClick={this.handleOnEditToggle}
                disabled={isLoading}
              />
              :
                <Button
                  icon="delete"
                  title="Cancella"
                  disabled={!this.canEdit || !canClone}
                  onClick={this.handleOnDelete}
                />
            }
          </Button.Group>
          :
          <Button.Group className="nowrap">
            <Button
              icon="plus"
              title="Aggiungi variazione"
              onClick={this.handleOnAddChild}
              disabled={!this.canSubmit() || this.inputHasErrors()}
            />
            {isCloningRow &&
              <Button
              icon="close"
              title="Annulla modifiche"
              onClick={this.handleOnEditToggle}
              disabled={isLoading}
            />
            }
          </Button.Group>
          }
        </td>
      </tr>
    );
  }
}

ChildItem.defaultProps = {
  deposit: null,
  duration: null,
  distance: null,
  monthly_rate: null,
};

ChildItem.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  deposit: PropTypes.number,
  duration: PropTypes.number,
  distance: PropTypes.number,
  monthly_rate: PropTypes.number,

  mainMonthlyRate: PropTypes.number.isRequired,
  mainDeposit: PropTypes.number.isRequired,
  mainDuration: PropTypes.number.isRequired,
  mainDistance: PropTypes.number.isRequired,
  hasError: PropTypes.bool.isRequired,
};

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  editMode: makeSelectChildEditing(),
});

export function mapDispatchToProps(dispatch) {
  return {
    storeChildOffer: value => dispatch(storeChildOffer(value)),
    deleteChildOffer: id => dispatch(deleteChildOffer(id)),
    setEditMode: id => dispatch(setEditMode(id)),
    unsetEditMode: () => dispatch(unsetEditMode()),
    updateChildOffer: (id, data) => dispatch(updateChildOffer(id, data)),
    resetErrors: () => dispatch(resetErrors()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withOfferChildsSaga,
  withOfferChildsReducer,
  withConnect,
)(ChildItem);
